module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh-cont"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/map",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("Map")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("PROLOGUE: ")]), _vm._v("Power and Pain")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER ONE:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("The Fall of Farcarinon")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER TWO:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Child of the Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER THREE:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Song of Amrethion")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER FOUR:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Veiled Path")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("INTERLUDE ONE:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fear and Betrayal")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER FIVE:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way of the Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER SIX:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaf and Sword, Flower and Shield")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER SEVEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The High King’s Army")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER EIGHT:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle City")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("INTERLUDE TWO:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knowledge and Treachery")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER NINE:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER TEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fire and Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER ELEVEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("War Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER TWELVE:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Empire Bought with Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("INTERLUDE THREE:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sorcery and Strategy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER THIRTEEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Parliament of Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER FOURTEEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Fly Before the Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER FIFTEEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hero Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER SIXTEEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wind and Dust")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("INTERLUDE FOUR:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invasion and Infamy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct-bot"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("CHAPTER SEVENTEEN:")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall of the Hundred Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Mercedes Lackey and James Mallory")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0